import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_stripe_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Pay with Stripe", -1)
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { id: "payment-form" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { id: "payment-element" }, null, -1)
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.$modals.STRIPE_MODAL,
    ref: "stripeModalRef",
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-sm btn-icon btn-active-color-primary",
            id: `${_ctx.$modals.STRIPE_MODAL}_close`,
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("button", {
              class: "btn btn-success mt-10 w-100",
              type: "submit",
              disabled: _ctx.submitting,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
            }, " Pay ", 8, _hoisted_11)
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}